import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import SimCardOutlined from "@material-ui/icons/SimCardOutlined";
import { useTranslation } from "react-i18next";
import "./css/PinPuk.scss";

interface IParams {
    pinNumber: string;
    pukNumber: string;
}

export const PinPuk = (props: IParams) => {
    const { pinNumber, pukNumber } = props;
    const { t } = useTranslation("accountDetails");

    return (
        <Card elevation={2}>
            <CardContent className="pinpuk">
                <Grid className="pinpuk-container" container spacing={8}>
                    <Grid item>
                        <Typography align="center" color="inherit" gutterBottom variant="h3">
                            {t("customerPIN")}
                        </Typography>
                        <div className="pinpuk__sim">
                            <SimCardOutlined fontSize="large" />
                            <Typography color="inherit" variant="h4">
                                {pinNumber}
                            </Typography>
                        </div>
                        <Typography align="center" color="inherit" gutterBottom variant="body1">
                            {t("originalPIN")}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography align="center" color="inherit" gutterBottom variant="h3">
                            {t("customerPUK")}
                        </Typography>
                        <div className="pinpuk__sim">
                            <SimCardOutlined fontSize="large" />
                            <Typography color="inherit" variant="h4">
                                {pukNumber}
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
